import { stopPropagation } from '../../../../libs/utils';

import { BaseType } from '../BaseType';
import IconButton from '../../../ui/IconButton';
import { LinkIcon } from '../../../ui/Icons';
import React from 'react';
import { TextType } from '../string';

export class LinkType extends BaseType {
  static getDefaultTypeParams() {
    return BaseType.extendTypeParams({
      valueDefault: '',
      formatAsComponent: true,
      formatEmpty: '---',
      displayAs: 'custom',
      placeholder: '',
      linkPrefix: '',
      linkSuffix: '',
      icon: LinkIcon,
      renderPreview: null,
      buttonCaption: undefined,
    });
  }

  static isEmpty = (value) => !value || value.length === 0;

  static renderer = ({
    value,
    onChange,
    renderPreview,
    linkPrefix,
    linkSuffix,
    icon: Icon,
    ...typeParams
  }) => {
    return (
      <>
        {TextType.render(value, onChange, {
          addonBefore: linkPrefix || undefined,
          addonAfter: (
            <>
              <span>{linkSuffix && linkSuffix + ' '}</span>
              <Icon
                onClick={() =>
                  window.open(`${linkPrefix}${value}${linkSuffix}`, '_BLANK')
                }
              />
            </>
          ),
          ...TextType.filterParams(typeParams),
        })}
        {renderPreview && renderPreview({ value, ...typeParams })}
      </>
    );
  };

  static displayer = ({ value, renderPreview, ...typeParams }) =>
    renderPreview
      ? renderPreview({ value, ...typeParams })
      : this.formatter(value, typeParams);

  static formatter = (
    value,
    { linkPrefix, linkSuffix, icon: Icon, formatEmpty, buttonCaption },
  ) => {
    if (LinkType.isEmpty(value)) return formatEmpty;
    const link = `${linkPrefix || ''}${value}${linkSuffix || ''}`;
    return (
      <span onClick={stopPropagation}>
        <IconButton
          icon={Icon ? <Icon /> : <LinkIcon />}
          text={buttonCaption ?? 'Abrir link'}
          type='primary'
          onClick={() => window.open(link, '_blank', 'noopener,noreferrer')}
        />
      </span>
    );
  };
}
